import React, { useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import { Container, Row, Col, Input, Button, Label } from "reactstrap"
import { toast } from "react-toastify"
import axios from "axios"

const FuelRewardSetting = () => {
  const [distance, setDistance] = useState(0)
  const [fuel, setFuel] = useState(0)
  const [loading, setLoading] = useState(true)

  const handleSave = async () => {
    try {
      const token = localStorage.getItem("authToken")
      const body = {
        reward_distance: parseInt(distance),
        reward_fuel: parseInt(fuel),
      }
      const response = await axios.post(
        `${process.env.REACT_APP_WEB_APP_URL}/api/web/reward-settings`,
        body,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      if (response.status == 200) {
        toast.success("Conversion rate hass been successfully changed", {
          autoClose: 3000,
        })
      } else {
        toast.error(response?.message || "Faield to make changes", {
          autoClose: 3000,
        })
      }
    } catch (error) {
      console.error(error)
      toast.error("Faield to make changes", { autoClose: 3000 })
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken")
        const response = await axios.get(
          `${process.env.REACT_APP_WEB_APP_URL}/api/web/reward-settings`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        if (response.status === 200) {
          const { reward_distance, reward_fuel } = response.data.data
          setDistance(reward_distance)
          setFuel(reward_fuel)
        }
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  document.title = "Fuel Reward Settings | Moeen"
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Home" breadcrumbItem="Fuel Reward Setting" />
        {loading ? (
          <Skeleton count={10} height={40} />
        ) : (
          <div className="page-content">
            <Container fluid>
              <Row>
                <Col>
                  <h4 className="mb-5">Conversion Rule</h4>
                </Col>
              </Row>
              <Row className="align-items-center mb-5">
                <Col md={3}>
                  <Label>Distance (Km)</Label>
                  <Input
                    value={distance}
                    className="border-black"
                    onChange={e => setDistance(e.target.value)}
                    type="number"
                  />
                </Col>
                <Col md={1} className="text-center">
                  <span className="fs-3 mx-pb-3">
                    <b>x</b>
                  </span>
                </Col>
                <Col md={3}>
                  <Label>Fuel (L)</Label>
                  <Input
                    value={fuel}
                    className="border-black"
                    onChange={e => setFuel(e.target.value)}
                    type="number"
                  />
                </Col>
                <Col md="auto" className="text-center"></Col>
              </Row>
              <Row>
                <Col className="text-end mt-5">
                  <Button
                    onClick={() => {
                      setDistance(0)
                      setFuel(0)
                    }}
                    color="success"
                    outline
                    className="me-3 px-4"
                  >
                    {" "}
                    Cancel{" "}
                  </Button>
                  <Button onClick={handleSave} color="success" className="px-4">
                    {" "}
                    Save{" "}
                  </Button>
                </Col>
              </Row>
            </Container>
          </div>
        )}
      </div>
    </div>
  )
}

export default FuelRewardSetting
